import {all} from "redux-saga/effects";
import ProjectListQuerySaga from "./ProjectListQuerySaga";
import RevisionListQuerySaga from "./RevisionListQuerySaga"
import ProfileListQuerySaga from "./ProfileListQuerySaga"
import RevisionSaveSaga from "./RevisionSaveSaga"
import FutureFeeConfigDeleteSaga from './FutureFeeConfigDeleteSaga'
import FutureFeeConfigQuerySaga from './FutureFeeConfigQuerySaga'
import FutureFeeConfigSaveSaga from './FutureFeeConfigSaveSaga'
import FeeTypeExampleSagas from './FeeTypeExampleSagas'

function createSagaArray() {
    return [
        ProjectListQuerySaga(),
        RevisionListQuerySaga(),
        ProfileListQuerySaga(),
        RevisionSaveSaga(),
        FutureFeeConfigDeleteSaga(),
        FutureFeeConfigQuerySaga(),
        FutureFeeConfigSaveSaga(),
        FeeTypeExampleSagas(),
    ];
}

export default function* combinedSaga() {
    const sagaArray = createSagaArray();
    yield all(sagaArray);
}
